<script>
  // eslint-disable-next-line
  import { toSrcsetString } from '@nrk/dh-basis-mediainfo/render-utils'
  export let mediaInfo
  export let loadingTechnique = 'lazy'
  export let fitImageAsCover = false

  const source = mediaInfo.sources.find((it) => it.type === 'image/webp')
  const { title, naturalDimensions } = mediaInfo
  const imageClass = fitImageAsCover ? 'image fit-cover' : 'image'
</script>

<picture>
  <source
    sizes="(min-width: 720px) 600, 100vw"
    type={source.type}
    srcset={toSrcsetString(source.srcset)}
  />
  <img
    sizes="(min-width: 720px) 600, 100vw"
    aria-hidden="true"
    alt={title}
    tabindex="-1"
    class={imageClass}
    loading={loadingTechnique}
    width={naturalDimensions.width}
    height={naturalDimensions.height}
  />
</picture>

<style>
  .image {
    display: block;
    width: 100%;
    height: 100%;
  }

  .image.fit-cover {
    object-fit: cover;
    object-position: top center;
  }
</style>
